import { defineStore } from "pinia";
import { ref } from "vue";

export const useMeasurementStore = defineStore("measurement", () => {
  const editableStates = ref<Record<number, boolean>>({});

  function registerMeasurement(measurementTypeId: number) {
    if (!(measurementTypeId in editableStates.value)) {
      editableStates.value = {
        ...editableStates.value,
        [measurementTypeId]: true,
      };
    }
  }

  function setReadOnly(measurementTypeId: number) {
    editableStates.value = {
      ...editableStates.value,
      [measurementTypeId]: false,
    };
  }

  function setEditable(measurementTypeId: number) {
    editableStates.value = {
      ...editableStates.value,
      [measurementTypeId]: true,
    };
  }

  function isEditable(measurementTypeId: number): boolean {
    return editableStates.value[measurementTypeId] ?? true;
  }

  return {
    editableStates,
    registerMeasurement,
    setReadOnly,
    setEditable,
    isEditable,
  };
});
